// extracted by mini-css-extract-plugin
module.exports = {"text":"component-module--text--1_52_","container":"component-module--container--3Kdv0"};